import {
  useAuthStore,
  useBookingFlowStore,
  usePatientStore,
  useUserStore,
} from "~/stores";

export const clearSessionData = () => {
  useUserStore.getState().clearStore();
  useAuthStore.getState().clearStore();
  usePatientStore.getState().clearStore();
  useBookingFlowStore.getState().clear();
};
